import { Fragment, FunctionComponent, memo } from "react";
import { IProps } from "./date-time-lower-axis-tick-formatter.types";
import "./date-time-lower-axis-tick-formatter.scss";
import { TimePeriodGroupBy } from "@edgetier/watchtower-types";
import { formatDateTickValue } from "utilities/format-date-tick-value";

/**
 * Tick formatter for the second X axis of a date time chart.
 */
const DateTimeLowerAxisTickFormatter: FunctionComponent<IProps> = ({ tickValue, dataLength, timePeriodGroup }) => {
    const { x, y, payload } = tickValue;
    const { offset, value } = payload;

    if (timePeriodGroup === TimePeriodGroupBy.Minutes) {
        // Transform to Date
        const minute = new Date(value).getMinutes();

        // Display label in the middle of each hour.
        if (minute === 30) {
            return (
                <text x={x} y={y} textAnchor="middle">
                    {formatDateTickValue(value, TimePeriodGroupBy.Hours)}
                </text>
            );
        }

        // Vertical line to separate days.
        if (minute === 59 && payload.index !== dataLength - 1) {
            const pathX = Math.floor(x + offset) + 0.5;
            return <path d={`M${pathX},${y + 3}v-15`} />;
        }
        return <Fragment />;
    }

    if (timePeriodGroup === TimePeriodGroupBy.Hours) {
        // Transform to Date
        const hour = new Date(value).getHours();

        // Display label in the middle of each day.
        if (hour === 12) {
            return (
                <text x={x} y={y} textAnchor="middle">
                    {formatDateTickValue(value, TimePeriodGroupBy.Days)}
                </text>
            );
        }

        // Vertical line to separate days.
        if (hour === 23 && payload.index !== dataLength - 1) {
            const pathX = Math.floor(x + offset) + 0.5;
            return <path d={`M${pathX},${y + 3}v-15`} />;
        }
        return <Fragment />;
    }

    return <Fragment />;
};

export default memo(DateTimeLowerAxisTickFormatter);
